import { Navigate } from "react-router-dom";
import HubPage from "@/pages/HubPage";
import { useLang, withLang } from "@/i18n";
import { MARKET } from "@/seo/market";

export default function MarketPage({ slug }) {
  const { lang } = useLang();
  const c = MARKET[slug];
  if (lang !== c.lang) return <Navigate to={withLang(lang, "/export")} replace />;
  return <HubPage key={slug} id={`market-${slug}`} content={{ [c.lang]: c, ro: c }} hero={c.hero} bg={c.bg} single />;
}
